import { Button, List, Space, Tag, Typography } from 'antd';
import { FC, ReactElement } from 'react';
import { ChevronRight, HouseFill } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { AppRoutes } from '../../../../../common/interfaces';
import { Page } from '../../../entities';
import { AwesomeNodePath } from '../../../../../common/components';
import { PagePublishedAtTag } from '../../../components';

interface Props {
  currentPage: number;
  pagesListItems: (Pick<Page, 'id' | 'title' | 'usageFor' | 'publishedAt' | 'createdAt' | 'updatedAt' | 'isPublished'> & {
    structureNode: (Pick<Page['structureNode'], 'id' | 'isHome' | 'extension' | 'path' | 'slug'> & {
      site: Pick<Page['structureNode']['site'], 'id' | 'name'>,
      pages: Pick<Page['structureNode']['pages'][0], 'id'>[]
    })
  })[];
  pagesListTotalItems: number;
  pagesListItemsPerPage: number;
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const PagesListView: FC<Props> = ({
  currentPage,
  pagesListItems,
  pagesListTotalItems,
  pagesListItemsPerPage,
  isLoading,
  handleChangePage
}) => {
  return (
    <List
      pagination={{
        current: currentPage,
        total: pagesListTotalItems,
        pageSize: pagesListItemsPerPage,
        showSizeChanger: false,
        showQuickJumper: true,
        disabled: isLoading,
        onChange: (page: number) => handleChangePage(page),
        showTotal: (total, range) => `${ range[0] }-${ range[1] } з ${ total } елементів`
      }}
      dataSource={ pagesListItems }
      renderItem={ ({ structureNode, ...page }): ReactElement => {
        return (
          <List.Item
            key={ page.id }
            actions={ [
              <Space key="tags">
                <Tag key="linkedPages" color="blue">
                  Варіантів сторінки:&nbsp;
                  { structureNode.pages.filter(el => el.id !== page.id).length }
                </Tag>
                <PagePublishedAtTag publishedAt={ page.publishedAt } isPublished={ page.isPublished }/>
              </Space>,
              <Link
                key="view"
                to={ AppRoutes.PagesById.replace(':siteId', structureNode.site.id).replace(':pageId', page.id) }
              >
                <Button type="text" icon={ <ChevronRight size={ 20 }/> }/>
              </Link>
            ] }
          >
            <Space size="small" direction="vertical">
              <Typography.Title style={{ margin: 0 }} level={ 4 }>
                { structureNode.isHome && (
                  <Tag color="blue" style={{ paddingTop: 2, paddingBottom: 2 }}>
                    <HouseFill size={ 16 }/>
                  </Tag>
                ) }
                { page.title }
              </Typography.Title>

              <AwesomeNodePath path={ structureNode.path }/>
            </Space>
          </List.Item>
        );
      } }
    />
  );
};
